import {
  DotLottie,
  DotLottieReact,
  FrameEvent,
} from "@lottiefiles/dotlottie-react";
import { useEffect, useState } from "react";

type LottieAnimationProps = {
  src: string;
  loop?: boolean;
  autoplay?: boolean;
  callbacks?: {
    onComplete?(): void;
  };
  shouldPlay?: boolean;
  freezeOnOffScreen?: boolean;
};

const LottieAnimation: React.FC<LottieAnimationProps> = ({
  src,
  loop,
  autoplay,
  shouldPlay,
  freezeOnOffScreen,
  callbacks,
}) => {
  const [dotLottie, setDotLottie] = useState<DotLottie | null>(null);
  const [reducedMotion, setReducedMotion] = useState(false);

  const dotLottieRefCallback = (dotLottie: DotLottie) => {
    setDotLottie(dotLottie);
  };

  useEffect(() => {
    if (shouldPlay && !reducedMotion) {
      dotLottie?.setFrame(0);
      dotLottie?.play();
    } else {
      dotLottie?.pause();
    }
  }, [shouldPlay]);

  useEffect(() => {
    function onComplete() {
      dotLottie?.setFrame(dotLottie?.totalFrames);
      dotLottie?.pause();
      if(callbacks && callbacks.onComplete) {
        callbacks.onComplete();
      }
    }

    function onLoad() {
      if (typeof window !== `undefined`) {
        const mediaQuery = window?.matchMedia(
          "(prefers-reduced-motion: reduce)"
        );
        if (mediaQuery.matches) {
          setReducedMotion(true);
        }
      }

      if (shouldPlay && !reducedMotion) {
        dotLottie?.play();
      }
    }

    if (dotLottie) {
      dotLottie.addEventListener("complete", onComplete);
      dotLottie.addEventListener("load", onLoad);
      // dotLottie.addEventListener("frame", onFrame);
    }

    return () => {
      if (dotLottie) {
        dotLottie.removeEventListener("complete", onComplete);
        dotLottie.removeEventListener("load", onLoad);
        // dotLottie.removeEventListener("frame", onFrame);
      }
    };
  }, [dotLottie]);

  let dpr = 1;

  if (typeof window !== `undefined`) {
    dpr = window.devicePixelRatio;
  }

  let shouldFreezeOffscreen = freezeOnOffScreen === undefined ? 
    false : freezeOnOffScreen;

  return (
    <DotLottieReact
      src={src}
      loop={loop}
      autoplay={autoplay && !reducedMotion}
      dotLottieRefCallback={dotLottieRefCallback}
      renderConfig={{
        autoResize: true,
        devicePixelRatio: dpr,
        freezeOnOffscreen: shouldFreezeOffscreen,
      }}
    />
  );
};

export default LottieAnimation;
